import { render, staticRenderFns } from "./ConfiguratorPricesEU.vue?vue&type=template&id=00f157c8&scoped=true"
import script from "./ConfiguratorPricesEU.vue?vue&type=script&lang=js"
export * from "./ConfiguratorPricesEU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f157c8",
  null
  
)

export default component.exports